import { Component, OnInit } from '@angular/core';
import { combineLatest, mergeMap, Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';
import { Revisione53Service } from '../../../revisione53.service';
import { HttpClient } from '@angular/common/http';
import { CoreState } from '@core/store/core.reducers';
import { Store } from '@ngrx/store';
import { CoreSelectors } from '@core/store/core.selectors';
import { ModalService } from '@core/services/modal.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Revisione53CoreSelectors } from '../../../store/selectors/core.selectors';
import { IRevisione } from '../../../models/interfaces/revisione.interface';
import { VerbaleRevisionePDFGenerator } from '../../../../print/TEMPLATE_VerbaleDiRevisioneMinisteroPDF44';
import pdfMake from 'pdfmake/build/pdfmake';
import { TipoDocumento } from '@core/helpers/constants';
import { ToastrService } from 'ngx-toastr';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'app-invia-verbale',
    templateUrl: './invia-verbale.component.html',
    styleUrls: ['./invia-verbale.component.scss'],
})
export class InviaVerbaleComponent implements OnInit {
    inviaVerbaleDisabled$: Observable<boolean>;
    isOnline$: Observable<boolean>;
    modaleinvio: NgxSmartModalComponent;
    stampaDisabled: boolean = false;
    caricaFile: boolean = false;
    verificaDisabled: boolean = true;
    inviaDisabled: boolean = true;
    fileVerbale: any = {
        base64: '',
        name: '',
    };

    constructor(
        private revisioneService: Revisione53Service,
        private http: HttpClient,
        private store: Store<CoreState>,
        private modalService: ModalService,
        private toastr: ToastrService
    ) {
        this.isOnline$ = this.store.select(CoreSelectors.isOnline);
    }

    ngOnInit(): void {
        const allFormsStatuses$: Observable<boolean>[] = this.revisioneService.navbarLinksRilevazione.filter((e) => !!e.isValid$).map((e) => e.isValid$);

        this.inviaVerbaleDisabled$ = combineLatest(allFormsStatuses$).pipe(
            map((allFormsStatuses) => allFormsStatuses.includes(false)),
            startWith(true)
        );

        // this.inviaVerbaleDisabled$ = of(false);
        this.stampaDisabled = true;
    }

    ngAfterViewInit() {
        this.modaleinvio = this.modalService.getModal('modaleinvio');
    }

    inviaVerbale(): void {
        this.revisioneService
            .getRevisioneWithBase64Files({ removeFileNameAndDetails: true })
            .pipe(
                take(1),
                // map(revisione => JsonHelper.restoreRevisioneJson(revisione)),
                mergeMap((revisione) => this.revisioneService.sendVerbale(revisione, true))
            )
            .subscribe((res) => {
                if (res.stato === 'OK') {
                    this.toastr.success(res.messaggio);
                    this.chiudiModaleInvio();
                } else {
                    this.toastr.error(res.messaggio);
                }
            });
    }

    stampaVerbale(): void {
        combineLatest([this.store.select(Revisione53CoreSelectors.getRevisione), this.revisioneService.getIsSezioneIValid$()])
            .pipe(take(1))
            .subscribe(([revisione, isSezioneIValid]: [IRevisione, boolean]) => {
                const generator = new VerbaleRevisionePDFGenerator(revisione, TipoDocumento.RILEVAZIONE, isSezioneIValid);
                const generatedPdfDefinition = generator.generate();
                let nomeFile = revisione.tipodocumento.includes('VERB') ? 'Verbale.pdf' : 'Accertamento.pdf';
                pdfMake.createPdf(generatedPdfDefinition).download(nomeFile);
                this.stampaDisabled = true;
                this.caricaFile = true;
            });
    }

    verificaVerbale(): void {
        let revClone = null;
        this.revisioneService
            .getRevisioneWithBase64Files({ removeFileNameAndDetails: true })
            .pipe(
                take(1),
                map((revisione) => {
                    revClone = cloneDeep(revisione);
                    const sezI = revClone.dati.my_Verbale.my_DocsPDF.my_SezioneI;
                    sezI.my_SezioneIPDF = this.fileVerbale.base64;
                    sezI.my_SezioneINomeFilePDF = this.fileVerbale.name;
                    return revClone;
                }),
                mergeMap((revisione) => this.revisioneService.verificaVerbale(revisione, true))
            )
            .subscribe((res) => {
                if (res.stato === 'OK') {
                    this.toastr.success(res.messaggio);
                    this.caricaFile = false;
                    this.verificaDisabled = true;
                    this.inviaDisabled = false;
                } else {
                    this.toastr.error(res.messaggio);
                }
            });
    }

    fileChange(event: any) {
        if (!event.target.files || !event.target.files[0]) {
            return;
        }
        const file: File = event.target.files[0];
        this.readFile(file);
    }

    readFile(file: File) {
        const fileType = file.type;
        const reader = new FileReader();
        let base64 = null;
        const that = this;
        reader.onload = function readSuccess(evt) {
            base64 = evt.target.result;
            base64 = base64.replace('data:' + fileType + ';base64,', '');
            that.fileVerbale.base64 = base64;
            that.fileVerbale.name = file.name;
            that.verificaDisabled = false;
        };
        reader.readAsDataURL(file);
    }

    apriModaleInvio(): void {
        this.stampaDisabled = false;
        this.caricaFile = false;
        this.verificaDisabled = true;
        this.inviaDisabled = true;
        this.modaleinvio.open();
    }

    chiudiModaleInvio(): void {
        this.modaleinvio.close();
    }
}
